module.exports = __webpack_public_path__ + "static/media/people15.72473ab8.jpeg";